import * as types from './mutation-types'
import Vue from 'vue'
const constants = require('@/util/constants')

export default {

    [types.PERSIST_CATEGORIES](state, { categories }) {
        state.categories = categories
    },

    [types.ADD_CATEGORY](state, { category }) {
        state.categories.push(category)
    },

    [types.UPDATE_CATEGORY](state, { category }) {
        for (let i = 0; i < state.categories.length; i++) {
            const element = state.categories[i]
            if (element.id === category.id) {
                Vue.set(state.categories[i], 'name', category.name)
            }
        }
    },

    [types.DELETE_CATEGORY](state, { id }) {
        for (let i = state.categories.length - 1; i >= 0; i--) {
            const element = state.categories[i];
            if (element.id === id) {
                state.categories.splice(i, 1)
            }
        }
    },

    [types.UPDATE_CURRENT_CATEGORY](state, { category }) {
        state.current_category = category
    },

    [types.PERSIST_SUPPORT_ARTICLES](state, { articles }) {
        state.articles = articles
    },

    [types.ADD_SUPPORT_ARTICLE](state, { article }) {
        state.articles.content.unshift(article)
    },

    [types.UPDATE_SUPPORT_ARTICLE](state, { article }) {
        // console.log('UPDATE_SUPPORT_ARTICLE:', article.id)
        for (let i = state.articles.content.length - 1; i >= 0; i--) {
            const element = state.articles.content[i]
            // console.log('element:', element.id)
            if (element.id === article.id) {
                state.articles.content.splice(i, 1)
                state.articles.content.unshift(article)
            }
        }
    },

    [types.UPDATE_CURRENT_ARTICLE](state, { article }) {
        state.current_article = article
    },

    [types.DELETE_SUPPORT_ARTICLE](state, { id }) {
        // console.log('DELETE_SUPPORT_ARTICLE:', id)
        for (let i = state.articles.content.length - 1; i >= 0; i--) {
            const element = state.articles.content[i];
            if (element.id === id) {
                state.articles.content.splice(i, 1)
            }
        }
    },

    [types.UPDATE_KNOWLEDGEBASE](state, { knowledgebase }) {
        //
        state.knowledgebase = knowledgebase
    }

}